import LumerAIAssistantAPI from 'dashboard/api/lumerai/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'LumerAIAssistant',
  API: LumerAIAssistantAPI,
});
